module.exports = __webpack_public_path__ + "Lato-Italic.0acac3839ae2c89cf8b5.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Italic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Italic.eot
// module chunks = styles